

















import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { ReportList } from '@/store/pages/report/index.d';
import Title from '../../components/Title.vue';
const Report = namespace('report');

@Component({
  components: {
    Title,
  },
})
export default class Index extends Vue {
  @Report.Getter('reportList') private reportList: ReportList[];
  @Report.Action('getReportList') private getReportList: any;
  private title: string[] = ['二手车业务'];
  private routerParams: string[] = [ 
    '/monthlyBusinessReport/level1',
    '/dailyBusinessReport/level1',
    '/monthlyIncomeReport/level1',
    '/dailyIncomeReport/level1',
    '/dailyStockReport/level1',
    '/dailyWechatReport/level1',
    '/monthlyProfitRateReport/level1',
    '/dailyBusinessTrendReport/level1'
  ]; 

  public mounted() {
    this.getReportList({ user_id: undefined});
  }
  public dateFormate(startDate: Date| string ) {
    const year = new Date(startDate).getFullYear();
    const month = new Date(startDate).getMonth() + 1;
    const day = new Date(startDate).getDate();
    return `${year}-${month}-${day}`;
  }
  public go(id: number, report_id: number) {
    const params: any = {
      path: `/index/report${this.routerParams[ id - 1 ]}`,
      query: {
        report_id,
        level: '1',
        start_date: this.dateFormate(new Date()),
        end_date: this.dateFormate(new Date()), 
        page: 1,
        count: 10,
        sort_field_id: 1,
        sort_order: 2,
      },
    }
    const { href } = this.$router.resolve(params);
    window.open(href, '_blank');
  }
}
